import { APP_KIND } from "@config";
import { MUSCLE_TTL_MS, OVERVIEW_TTL_MS, SESSION_TTL_MS, TREND_TTL_MS, v2FetchCached } from "../api/v2Cache";

function clubRoot(clubId) {
  return `/${APP_KIND}/clubs/${clubId}`;
}

function query(params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value == null || value === "") return;
    search.set(key, String(value));
  });
  const encoded = search.toString();
  return encoded ? `?${encoded}` : "";
}

export function fetchClubSessions(clubId, { from, to, season } = {}) {
  return v2FetchCached(`${clubRoot(clubId)}/sessions${query({ from, to, season })}`, {
    ttlMs: SESSION_TTL_MS,
  });
}

export function fetchClubAvailability(clubId, { date, season } = {}) {
  return v2FetchCached(`${clubRoot(clubId)}/availability${query({ date, season })}`, {
    ttlMs: OVERVIEW_TTL_MS,
  });
}

export function fetchInternalLoad(clubId, { date, period, season } = {}) {
  return v2FetchCached(`${clubRoot(clubId)}/internal-load${query({ date, period, season })}`, {
    ttlMs: OVERVIEW_TTL_MS,
  });
}

export function fetchInternalLoadTrends(clubId, { period, date, playerIds, season } = {}) {
  return v2FetchCached(
    `${clubRoot(clubId)}/internal-load/trends${query({
      period,
      date,
      player_ids: playerIds?.length ? playerIds.join(",") : undefined,
      season,
    })}`,
    { ttlMs: TREND_TTL_MS },
  );
}

export function fetchPlayerMuscles(clubId, playerId, { date, period, season } = {}) {
  return v2FetchCached(
    `${clubRoot(clubId)}/players/${playerId}/internal-load/muscles${query({ date, period, season })}`,
    { ttlMs: MUSCLE_TTL_MS },
  );
}
